import{emit as e}from"@rsql/emitter";function t(t,n){return e(t,n)}export{t as serializeRSQL};
//# sourceMappingURL=rsql-string-serializer.mjs.map